import { render, staticRenderFns } from "./Lgx328522999873404928.vue?vue&type=template&id=15c251fe&"
import script from "./Lgx328522999873404928.vue?vue&type=script&lang=js&"
export * from "./Lgx328522999873404928.vue?vue&type=script&lang=js&"
import style0 from "./Lgx328522999873404928.vue?vue&type=style&index=0&id=15c251fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports